export const testimonials = [
  {
    initials: 'VR',
    name: 'Valeria R.',
    location: 'Córdoba',
    role: 'Entrenadora',
    text: 'Che, yo pensé que iba a ser más de lo mismo pero nada que ver. Organicé todo el programa en una tarde. El lunes arranqué diferente.',
  },
  {
    initials: 'CM',
    name: 'Carolina M.',
    location: 'Buenos Aires',
    role: 'Profesora',
    text: 'Me pasó que una alumna tuvo contracciones en clase y no supe qué hacer. Compré el sistema y ahora tengo el protocolo en la carpeta. Ya no me agarra la duda.',
  },
  {
    initials: 'JP',
    name: 'Jimena P.',
    location: 'Rosario',
    role: 'Coach',
    text: 'La verdad es que antes buscaba ejercicios sueltos en internet y nunca quedaban bien. Ahora abro el tomo y ya está. Re diferente.',
  },
]

export const moreTestimonials = [
  {
    initials: 'AL',
    name: 'Andrea L.',
    age: 34,
    location: 'Santa Fe',
    role: 'Profesora',
    text: 'Lo que más me cambió fue la nota para el médico. Me empezaron a derivar pacientes. Antes ni me pelaban.',
  },
  {
    initials: 'MF',
    name: 'Melina F.',
    age: 28,
    location: 'Tucumán',
    role: 'Entrenadora',
    text: 'Yo venía improvisando hace tres años. Con el sistema fue todo diferente. Mis alumnas me empezaron a recomendar. No puedo creer que no lo tuve antes.',
  },
  {
    initials: 'RC',
    name: 'Romina C.',
    age: 41,
    location: 'Mendoza',
    role: 'Coach',
    text: 'Una vez se me fue la mano con la intensidad y la alumna se mareó. No sabía qué hacer. Ahora tengo el protocolo ahí, impreso en la carpeta. Ya no me pasa más.',
  },
  {
    initials: 'NG',
    name: 'Natalia G.',
    age: 35,
    location: 'CABA',
    role: 'Profesora',
    text: 'Las planillas de seguimiento me cambiaron todo. Antes no tenía nada escrito. Ahora cada clase queda registrada. Me siento una profesional de verdad.',
  },
]

export const tomos = [
  {
    id: 'T1',
    name: 'Fisiología y Biomecánica',
    months: 'Base Científica',
    content:
      'La base científica que necesitás antes de empezar. Los 9 cambios del embarazo y su impacto en el ejercicio. Sistema de Semáforos Verde / Amarillo / Rojo. Contraindicaciones absolutas y relativas. Marco legal en Argentina 2026. Checklist pre-clase lista para usar.',
    icon: '📘',
  },
  {
    id: 'T2',
    name: 'Primer Trimestre',
    months: 'Semanas 1 a 13',
    content:
      'Protocolo de primera clase prenatal. Adaptación a náuseas, fatiga y síntomas frecuentes. 40 ejercicios con descripción técnica completa. Plan de 12 semanas listo para aplicar. Fichas de clase por semana.',
    icon: '📗',
  },
  {
    id: 'T3',
    name: 'Segundo Trimestre',
    months: 'Semanas 14 a 27',
    content:
      'Protocolo clave de la semana 20. Evaluación y trabajo de diástasis. 40 ejercicios del segundo trimestre. Progresión de fuerza adaptada. Inicio de la preparación para el parto.',
    icon: '📙',
  },
  {
    id: 'T4',
    name: 'Tercer Trimestre',
    months: 'Semanas 28 a 40',
    content:
      'Las 3 técnicas de respiración para el parto. Posiciones de trabajo de parto activo. Apertura pélvica y movilidad avanzada. Protocolo de la última clase prenatal. Ficha de técnicas del parto para entregar.',
    icon: '📕',
  },
  {
    id: 'T5',
    name: 'Emergencias, Legal y Postparto',
    months: 'Protocolos y Legal',
    content:
      '12 protocolos de emergencia paso a paso. 4 árboles de decisión para situaciones críticas. 7 documentos legales listos para firmar. Programa postparto: 4 fases y 30 ejercicios. Marco legal del profesional prenatal Argentina 2026.',
    icon: '📓',
  },
]

export const bonuses = [
  {
    id: '01',
    icon: '📋',
    name: '40 Fichas de Clase Listas',
    desc: 'Una ficha por semana. Semana 1 a 40. Imprimís, usás y archivás. Sin armar nada desde cero.',
    value: '$12.000',
  },
  {
    id: '02',
    icon: '🥗',
    name: 'Guía de Nutrición para el Embarazo Activo',
    desc: 'Hidratación, hipoglucemia, calambres, diabetes gestacional. Sin ser nutricionista.',
    value: '$10.000',
  },
  {
    id: '03',
    icon: '🩺',
    name: 'Comunicación con el Equipo Médico',
    desc: '20+ modelos de nota listos para enviar al médico. El sistema de derivaciones que genera credibilidad.',
    value: '$12.000',
  },
  {
    id: '04',
    icon: '💪',
    name: '120 Ejercicios Adaptados por Síntoma',
    desc: '¿Tu alumna llega con dolor lumbar? Abrís la sección. ¿Con náuseas? Abrís la sección. 30 segundos y ya está.',
    value: '$14.000',
  },
  {
    id: '05',
    icon: '📈',
    name: 'Marketing y Ventas Prenatal',
    desc: '7 guiones de WhatsApp que convierten. 15 plantillas de Instagram listas para publicar. Plan de 90 días para llenar tu agenda.',
    value: '$12.000',
  },
]

export const faqs = [
  {
    q: '¿Sirve si recién empiezo a trabajar con embarazadas?',
    a: 'Sí. El Tomo 1 te da toda la base que necesitás antes de la primera clase.',
  },
  {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después del pago recibís un email con acceso a los 5 tomos y los 5 bonos en PDF. En menos de 5 minutos lo tenés disponible.',
  },
  {
    q: '¿Puedo empezar si ya tengo alumnas en el tercer trimestre?',
    a: 'Sí. Cada tomo está dividido por trimestre. Abrís el Tomo 4 y empezás desde donde están tus alumnas ahora.',
  },
  {
    q: '¿La garantía es real?',
    a: '100%. Escribís a compradigitalyaa@gmail.com dentro de los 7 días y te devolvemos el dinero. Sin preguntas.',
  },
]

export const purchaseNotifications = [
  {
    name: 'Valeria R.',
    city: 'Córdoba',
    plan: 'Sistema Entrenamiento Prenatal Pro',
  },
  {
    name: 'Carolina M.',
    city: 'Buenos Aires',
    plan: 'Sistema Completo + Postparto',
  },
  {
    name: 'Jimena P.',
    city: 'Rosario',
    plan: 'Sistema Entrenamiento Prenatal Pro',
  },
  { name: 'Andrea L.', city: 'Santa Fe', plan: 'Sistema Completo + Postparto' },
  {
    name: 'Melina F.',
    city: 'Tucumán',
    plan: 'Sistema Entrenamiento Prenatal Pro',
  },
  { name: 'Romina C.', city: 'Mendoza', plan: 'Sistema Completo + Postparto' },
  {
    name: 'Natalia G.',
    city: 'CABA',
    plan: 'Sistema Entrenamiento Prenatal Pro',
  },
  { name: 'Diego F.', city: 'Neuquén', plan: 'Sistema Completo + Postparto' },
  {
    name: 'Lucía M.',
    city: 'Mar del Plata',
    plan: 'Sistema Entrenamiento Prenatal Pro',
  },
  {
    name: 'Martín S.',
    city: 'Bahía Blanca',
    plan: 'Sistema Completo + Postparto',
  },
]
